import { Injectable } from '@angular/core';
import { QuestionBase } from '../common/question-base';
import { QuestionText } from '../common/question-text';
import { QuestionCheckbox } from '../common/question-checkbox';
import { QuestionChecklist } from '../common/question-checklist';
import { QuestionBoolean } from '../common/question-boolean';
import { QuestionRadio } from '../common/question-radio';
import { QuestionDropdown } from '../common/question-dropdown';
import { SurveyFull } from '../common/survey-full';
import { QuestionsOptions } from '../common/questions-options';
import { UntypedFormArray, UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { QuestionMultiLine } from '../common/question-multi-line';
import { ValidatorFn, ValidationErrors } from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class QuestionControlService {

  constructor() { }

  getQuestions(SurveyFull: SurveyFull): QuestionBase<string>[] {
    const questionsTemp = [];
    const temp = SurveyFull.questions;
    temp.forEach(q => {
      let ques;
      // oneline
      // multiline
      // radio
      // dropdown
      // checkbox_multiselect
      if (q.type.typeName === "oneline") {
        ques = new QuestionText({
          key: q.id.toString(),
          validation: q.validation,
          required: q.required,
          label: q.question,
        });
      } else if(q.type.typeName === "multiline") {
        ques = new QuestionMultiLine({
          key: q.id.toString(),
          validation: q.validation,
          required: q.required,
          label: q.question,
        });
      } else if (q.type.typeName === "checkbox") {
        ques = new QuestionCheckbox({
          key: q.id.toString(),
          label: q.question,
          validation: q.validation,
          required: q.required,
          options: this.getOptions(q.options)
        })
      } else if (q.type.typeName === "checklist") {
        ques = new QuestionChecklist({
          key: q.id.toString(),
          label: q.question,
          validation: q.validation,
          required: q.required,
          options: this.getOptions(q.options)
        })
      } else if (q.type.typeName === "boolean") {
        ques = new QuestionBoolean({
          key: q.id.toString(),
          label: q.question,
          validation: q.validation,
          required: q.required,
          options: this.getOptions(q.options)
        })
      } else if (q.type.typeName === "radio") {
        ques = new QuestionRadio({
          key: q.id.toString(),
          label: q.question,
          validation: q.validation,
          required: q.required,
          options: this.getOptions(q.options)
        })
      } else if (q.type.typeName === "dropdown") {
        ques = new QuestionDropdown({
          key: q.id.toString(),
          label: q.question,
          validation: q.validation,
          required: q.required,
          options: this.getOptions(q.options)
        })
      }
      questionsTemp.push(ques);
    });
    return questionsTemp;
  }

  getOptions(options: QuestionsOptions[]): { key: string, value: string }[] {
    const out = [];
    options.forEach(option => {
      out.push({key:option.id.toString(), value: option.name});
    })
    return out;
  }

  toFormGroup(questions: QuestionBase<string>[]) {
    const group: any = {};

    questions.forEach(question => {
      // checkbox because we set controlType as checkbox in QuestionCheckbox class even though we are getting
      // checkbox_multiselect from database
      if (question.controlType === "boolean") {
        group[question.key] = new UntypedFormControl(question.value || "", Validators.requiredTrue);
        // group[question.key] = new FormArray([], this.minSelectedCheckboxes(1));
        // this.addCheckboxes(question.options, group[question.key]);
      } else if (question.controlType === "checklist") {
        // group[question.key] = new FormControl(question.value || "", Validators.requiredTrue);
        group[question.key] = new UntypedFormArray([], this.minSelectedCheckboxes(1));
        this.addCheckboxes(question.options, group[question.key]);
      } else {
        if (question.validation != "" || question.validation != null) {
          if (question.validation === "alpha") {
            group[question.key] = new UntypedFormControl(question.value || "", [Validators.required, Validators.pattern('[a-zA-Z .]+')]);
          } else if (question.validation === "numeric") {
            group[question.key] = new UntypedFormControl(question.value || "", [Validators.required, Validators.pattern('[0-9]+')]);
          } else if (question.validation === "alpha-numeric"){  // alpha-numeric
            group[question.key] = new UntypedFormControl(question.value || "", [Validators.required, Validators.pattern('[a-zA-Z0-9_ @.]+')]);
          } else if (question.validation === "email"){  // email
            group[question.key] = new UntypedFormControl(question.value || "", [Validators.required, Validators.email]);
          } else {
            group[question.key] = new UntypedFormControl(question.value || "", [Validators.required]);
          }
        } else {
          group[question.key] = new UntypedFormControl(question.value || "", Validators.required);
        }
      }
    });
    return new UntypedFormGroup(group);
  }

  private minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: UntypedFormGroup) => {
      if (formArray instanceof UntypedFormArray) {
        const totalSelected = formArray.controls
          .map((control) => control.value)
          .reduce((prev, next) => (next ? prev + next : prev), 0);
        return totalSelected >= min ? null : { required: true };
      }

      throw new Error('formArray is not an instance of FormArray');
    };

    return validator;
  }

  private addCheckboxes(options: {key: string, value: string}[], formArray: UntypedFormArray) {
    options.forEach(() => formArray.push(new UntypedFormControl(false)));
  }
}
